/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountNativeDetailsForAzureStack extends models.ServiceAccountNativeDetailsBaseForCloud {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountNativeDetailsForAzureStack");
    }

    getFixupPrototypeFunction() { return ServiceAccountNativeDetailsForAzureStack.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountNativeDetailsForAzureStack>): ServiceAccountNativeDetailsForAzureStack {
        let obj = Object.assign(new ServiceAccountNativeDetailsForAzureStack(), model);
        ServiceAccountNativeDetailsForAzureStack.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountNativeDetailsForAzureStack>): ServiceAccountNativeDetailsForAzureStack {
        if (!model) return null;
        return ServiceAccountNativeDetailsForAzureStack.newInstance(<ServiceAccountNativeDetailsForAzureStack> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountNativeDetailsForAzureStack) {
        if (!obj) return;

        models.ServiceAccountNativeDetailsForAzureStack.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountNativeDetailsForAzureStack): boolean {
        if (models.ServiceAccountNativeDetailsBaseForCloud.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountNativeDetailsForAzureStack.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.default_values) {
            models.SelfServiceDefaultValuesForAzure.fixupPrototype(this.default_values);
        }
    }

    /**
     * Subscription Id. This is a required field.
     */
    subscription_id: string;

    /**
     * SelfService Default Values
     */
    default_values: models.SelfServiceDefaultValuesForAzure;

}
